import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo, useEffect, useState, useCallback } from "react";
import { findUsedVendorsForDeclaration } from "@devowl-wp/cookie-consent-web-client";
import { useBanner, Checkbox, LinkToggle, CookieProperty, useBannerStylesheet, generatePluralText, useDurationText, getTcfDataRetentionTimeForPurpose } from "../../../..";
import { extendCommonGroupsStylesheet, extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
import { reactNl2Br, jsxJoin } from "@devowl-wp/react-utils";
const BannerTcfDeclaration = (param)=>{
    let { declaration, id } = param;
    const { Link, Cookie } = useBannerStylesheet().extend(...extendCommonStylesheet).extend(...extendCommonGroupsStylesheet);
    const [isOpen, setIsOpen] = useState(false);
    const generateDurationText = useDurationText();
    const { tcf: { gvl, model }, tcfFilterBy, group: { descriptionFontSize }, activeAction, i18n: { purpose, showMore, hideMore, tcf: { example, vendors, vendorsCount, dataRetentionPeriod } } } = useBanner();
    const { [declaration]: { [id.toString()]: declarationObj } } = gvl;
    const { name, description, illustrations } = declarationObj;
    const isEssentialDeclaration = [
        "specialPurposes",
        "features",
        "dataCategories"
    ].indexOf(declaration) > -1;
    const isDisabled = activeAction === "history" || isEssentialDeclaration;
    const checkedList = isEssentialDeclaration ? undefined : model[declaration === "specialFeatures" ? "specialFeatureOptins" : tcfFilterBy === "legInt" ? "purposeLegitimateInterests" : "purposeConsents"];
    // Save checked in own state cause the model does not trigger a re-render
    const modelIsChecked = isEssentialDeclaration || !!(checkedList == null ? void 0 : checkedList.has(id));
    const [isChecked, setIsChecked] = useState(modelIsChecked);
    // Update our checked state depending on the original value (e.g. switch of legInt | consent filter)
    useEffect(()=>{
        setIsChecked(modelIsChecked);
    }, [
        modelIsChecked
    ]);
    const handleCheckbox = useCallback((checked)=>{
        try {
            checkedList[checked ? "set" : "unset"](id);
            setIsChecked(checked);
        } catch (e) {
        // Silence is golden.
        }
    }, [
        id,
        checkedList,
        setIsChecked
    ]);
    // Calculate all vendors using this declaration
    const useVendors = useMemo(()=>findUsedVendorsForDeclaration(gvl, model, id, declaration, tcfFilterBy === "legInt", true), [
        gvl,
        model,
        id,
        declaration,
        tcfFilterBy
    ]);
    return /*#__PURE__*/ _jsxs(Cookie, {
        children: [
            /*#__PURE__*/ _jsxs(Checkbox, {
                hideCheckbox: [
                    "purposes",
                    "specialFeatures"
                ].indexOf(declaration) === -1,
                isChecked: isChecked,
                isDisabled: isDisabled,
                fontSize: descriptionFontSize,
                onToggle: handleCheckbox,
                after: /*#__PURE__*/ _jsx(LinkToggle, {
                    onToggle: setIsOpen,
                    showMore: showMore,
                    hideMore: hideMore,
                    bullets: true
                }),
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: name
                    }),
                    " (",
                    generatePluralText(useVendors.length, ...vendorsCount),
                    ")"
                ]
            }),
            isOpen && /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(CookieProperty, {
                        label: purpose,
                        value: reactNl2Br(description),
                        children: (illustrations == null ? void 0 : illustrations.length) > 0 && illustrations.map((illustration, i)=>/*#__PURE__*/ _jsx(CookieProperty, {
                                label: `${example} #${i + 1}`,
                                value: illustration
                            }, illustration))
                    }),
                    /*#__PURE__*/ _jsx(CookieProperty, {
                        label: vendors,
                        value: jsxJoin(useVendors.map((param)=>{
                            let { id: vendorId, name, urls, dataRetention } = param;
                            return /*#__PURE__*/ _jsxs(Link, {
                                href: (urls == null ? void 0 : urls[0].privacy) || "about:blank",
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    name,
                                    [
                                        "purposes",
                                        "specialPurposes"
                                    ].indexOf(declaration) > -1 && dataRetention ? ` (${dataRetentionPeriod}: ${generateDurationText(getTcfDataRetentionTimeForPurpose(dataRetention, id, false), "d")})` : ""
                                ]
                            }, vendorId);
                        }), ", ")
                    })
                ]
            })
        ]
    });
};
export { BannerTcfDeclaration };
